import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { costPages } from "../data/costPages";

export default function CostSocialMediaOesterreich() {
  return <ContentPageTemplate {...costPages.socialMedia} />;
}
